import { resolveDestination } from "routing/to";
import { useTranslation } from "react-i18next";
import { useAuthState } from "../../../../hooks";
import { NavigationDrawerLinkStyles } from "../NavigationDrawerButton.styles";
import { NavigationButtonWithoutSubroutesProps } from "../../../../types";

export const NavigationDrawerButtonWithoutSubroutes = ({
  translationKey,
  path,
  shopId,
  onClick,
  requiredPermission
}: NavigationButtonWithoutSubroutesProps) => {
  const { checkPermission } = useAuthState();

  const { t } = useTranslation();

  if (requiredPermission && !checkPermission(requiredPermission)) {
    return null;
  }

  const to = resolveDestination(path.path, shopId);
  if (to === undefined) return null;

  return (
    <NavigationDrawerLinkStyles to={to} onClick={onClick}>
      {t(translationKey)}
    </NavigationDrawerLinkStyles>
  );
};
